export default __webpack_public_path__ + "static/media/Picked-up.a7b32e8a.png";